define('modules/start/products/automation/info/view',['require','exports','module','env','views/BaseView','ldsh!./template'],function (require, exports, module) {
    "use strict";

    var Config = require("env");
    var BaseView = require("views/BaseView");

    var Layout = BaseView.extend({
        template: require("ldsh!./template")
    });

    module.exports = Layout;
});

